import React, { useEffect, useState } from "react";
import {
  adminListInquiries,
  adminUpdateContactUs,
  fetchContactUs,
} from "../../../utils/contactUsApi";

const emptyForm = {
  heading: "",
  subheading: "",
  description: "",
  whatsappNumber: "7417539900",
  phone: "",
  email: "",
  openHours: "",
  locationName: "",
  addressLine1: "",
  addressLine2: "",
  mapEmbedUrl: "",
  mapUrl: "",
};

export default function ContactUsAdmin() {
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  const [inquiries, setInquiries] = useState([]);
  const [inqMeta, setInqMeta] = useState({ page: 1, totalPages: 1 });
  const [inqError, setInqError] = useState("");

  useEffect(() => {
    fetchContactUs()
      .then((data) => {
        if (!data) return;
        setForm((prev) => ({ ...prev, ...data }));
      })
      .catch(() => {});
  }, []);

  const loadInquiries = async (page = 1) => {
    setInqError("");
    try {
      const data = await adminListInquiries({ page, limit: 50 });
      setInquiries(data?.items || []);
      setInqMeta({ page: data?.page || 1, totalPages: data?.totalPages || 1 });
    } catch (err) {
      setInqError(
        err?.response?.data?.message ||
          "Failed to load inquiries (admin login required)."
      );
    }
  };

  useEffect(() => {
    loadInquiries(1);
  }, []);

  const handleField = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSaved(false);
    setError("");

    try {
      await adminUpdateContactUs(form);
      setSaved(true);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Failed to save contact settings (admin login required)."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container pt-5 mt-5" style={{ maxWidth: 1150 }}>
      <h3 className="mb-1">Contact Us Settings</h3>
      <p className="text-muted small mb-4">
        Manage the Contact Us page info (phone, email, map, WhatsApp number) and
        view submitted inquiries.
      </p>

      {error && <div className="alert alert-danger">{error}</div>}
      {saved && (
        <div className="alert alert-success">
          Contact Us settings saved successfully.
        </div>
      )}

      <form onSubmit={handleSubmit} className="card p-4 shadow-sm mb-4">
        <h5 className="mb-3">Page Content</h5>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Subheading</label>
            <input
              name="subheading"
              className="form-control"
              value={form.subheading}
              onChange={handleField}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Heading</label>
            <input
              name="heading"
              className="form-control"
              value={form.heading}
              onChange={handleField}
            />
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Description</label>
            <textarea
              name="description"
              className="form-control"
              rows="3"
              value={form.description}
              onChange={handleField}
            />
          </div>
        </div>

        <h5 className="mt-3 pt-3 border-top mb-3">Contact Details</h5>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label">WhatsApp Number</label>
            <input
              name="whatsappNumber"
              className="form-control"
              value={form.whatsappNumber}
              onChange={handleField}
              placeholder="7417539900"
            />
            <div className="form-text">
              Use digits only (country code optional). Example: 917417539900
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Phone</label>
            <input
              name="phone"
              className="form-control"
              value={form.phone}
              onChange={handleField}
              placeholder="+91 ..."
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Email</label>
            <input
              name="email"
              className="form-control"
              value={form.email}
              onChange={handleField}
              placeholder="info@..."
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Open Hours</label>
            <input
              name="openHours"
              className="form-control"
              value={form.openHours}
              onChange={handleField}
            />
          </div>
        </div>

        <h5 className="mt-3 pt-3 border-top mb-3">Location & Map</h5>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Location Name</label>
            <input
              name="locationName"
              className="form-control"
              value={form.locationName}
              onChange={handleField}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Address Line 1</label>
            <input
              name="addressLine1"
              className="form-control"
              value={form.addressLine1}
              onChange={handleField}
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Address Line 2</label>
            <input
              name="addressLine2"
              className="form-control"
              value={form.addressLine2}
              onChange={handleField}
            />
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Google Map Embed URL</label>
            <input
              name="mapEmbedUrl"
              className="form-control"
              value={form.mapEmbedUrl}
              onChange={handleField}
              placeholder="https://www.google.com/maps/embed?pb=..."
            />
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Google Map Link URL</label>
            <input
              name="mapUrl"
              className="form-control"
              value={form.mapUrl}
              onChange={handleField}
              placeholder="https://www.google.com/maps/place/..."
            />
          </div>
        </div>

        <div className="d-flex justify-content-end mt-3">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Saving..." : "Save Contact Settings"}
          </button>
        </div>
      </form>

      <div className="card p-4 shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <h5 className="mb-1">Contact Inquiries</h5>
            <p className="text-muted small mb-0">
              Messages submitted from the Contact Us page are stored in the
              database.
            </p>
          </div>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => loadInquiries(inqMeta.page)}
          >
            Refresh
          </button>
        </div>

        {inqError ? <div className="alert alert-warning">{inqError}</div> : null}

        <div className="table-responsive">
          <table className="table table-sm table-striped align-middle">
            <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Subject</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.length ? (
                inquiries.map((it) => (
                  <tr key={it._id}>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {it.createdAt ? new Date(it.createdAt).toLocaleString() : ""}
                    </td>
                    <td>{it.name}</td>
                    <td>{it.phone}</td>
                    <td>{it.email}</td>
                    <td>{it.subject}</td>
                    <td style={{ minWidth: 280 }}>{it.message}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-muted">
                    No inquiries yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            disabled={inqMeta.page <= 1}
            onClick={() => loadInquiries(Math.max(1, inqMeta.page - 1))}
          >
            Prev
          </button>
          <div className="text-muted small">
            Page {inqMeta.page} of {inqMeta.totalPages}
          </div>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            disabled={inqMeta.page >= inqMeta.totalPages}
            onClick={() => loadInquiries(Math.min(inqMeta.totalPages, inqMeta.page + 1))}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

